import { generateUrl } from '@routes/util';
import { ROUTES } from '@constants/routes';
import type { InitiativeGroup } from '../../../types/initiative-group';

export const getManageGroupsUrl = (initiativeId: string) => {
  return generateUrl(ROUTES.MANAGE_SUBSIDIARY_GROUPS, { initiativeId });
};

export const getCreateGroupUrl = (initiativeId: string) => {
  return `${getManageGroupsUrl(initiativeId)}/create`;
};

export const getEditGroupUrl = (initiativeId: string, groupId: string) => {
  return `${getManageGroupsUrl(initiativeId)}/${groupId}`;
};

// Only allow a-z, A-Z, 0-9, and spaces
const NAME_REGEX = /^[a-zA-Z0-9\s]+$/;

export const isValidGroupName = (name: string): boolean => {
  return name.length > 0 && NAME_REGEX.test(name);
};

export const hasInvalidCharacters = (name: string): boolean => {
  return name.length > 0 && !NAME_REGEX.test(name);
};

export const formatDateDisplay = (dateString?: string): string => {
  if (!dateString) {
    return '-';
  }
  try {
    return new Date(dateString).toLocaleDateString();
  } catch {
    return '-';
  }
};

export const isNameDuplicate = (
  name: string,
  existingGroups: InitiativeGroup[],
  currentGroupId?: string,
): boolean => {
  return existingGroups.some(
    (g) => g._id !== currentGroupId && g.name?.trim().toLowerCase() === name.trim().toLowerCase(),
  );
};

export const getInvalidNameMessage = (
  name: string,
  isDuplicate: boolean,
  hasInvalidChars: boolean,
): string | null => {
  if (name.length === 0) return null;
  if (isDuplicate) return 'Name already exists, please choose another';
  if (hasInvalidChars) return 'Only characters from a-z and 0-9 are supported';
  return null;
};
